import { useState, useEffect } from "react";
import axios from "axios";
import { FaEye, FaTrash, FaDownload } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ManageTeacherApplications() {
  const [applications, setApplications] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Fetch teacher application data from API
  const fetchApplications = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/recruitment`);
      setApplications(response.data.applications);
    } catch (error) {
      console.error("Error fetching teacher applications:", error);
      toast.error("Failed to fetch teacher application data.");
    }
  };

  useEffect(() => {
    fetchApplications(); // Fetch data when the component mounts
  }, []);

  // Handle view button
  const handleViewClick = (application) => {
    setSelectedApplication(application);
    setShowModal(true);
  };

  // Handle delete application
  const handleDelete = async (_id) => {
    try {
      await axios.delete(`/api/v1/recruitment/${_id}`);
      setApplications(applications.filter((application) => application._id !== _id));
      toast.success("Application deleted successfully!");
    } catch (error) {
      console.error("Error deleting application:", error);
      toast.error("Failed to delete application.");
    }
  };

  // Handle resume download
  const handleDownloadResume = (resumeUrl) => {
    const link = document.createElement("a");
    link.href = resumeUrl;
    link.download = resumeUrl.split("/").pop(); // Use filename from the URL
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setSelectedApplication(null);
  };

  return (
    <div className="container mx-auto px-4 py-6 space-y-8">
      <ToastContainer position="top-center" autoClose={3000} />

      <div className="bg-[#00BFA5] text-black text-center font-bold py-4 px-6 max-w-4xl mx-auto text-xl sm:text-2xl md:text-3xl rounded-lg shadow-lg">
        Teacher Application Directory - Manage Applications
      </div>

      <div className="overflow-x-auto bg-white shadow-lg rounded-lg border-t-4 border-teal-500">
        <table className="min-w-full table-auto border-collapse relative">
          <thead className="bg-[#00BFA5] text-white">
            <tr>
              <th className="px-2 py-3 text-left text-xs sm:text-sm font-semibold">S No.</th>
              <th className="px-2 py-3 text-left text-xs sm:text-sm font-semibold">Name</th>
              <th className="hidden sm:table-cell px-2 py-3 text-left text-xs sm:text-sm font-semibold">Email</th>
              <th className="hidden sm:table-cell px-2 py-3 text-left text-xs sm:text-sm font-semibold">Phone</th>
              <th className="hidden sm:table-cell px-2 py-3 text-left text-xs sm:text-sm font-semibold">Subject</th>
              <th className="px-2 py-3 text-left text-xs sm:text-sm font-semibold">Resume</th>
              <th className="px-2 py-3 text-center text-xs sm:text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {applications?.map((application, index) => (
              <tr key={application._id} className="border-b hover:bg-teal-50 transition duration-200 ease-in-out">
                <td className="px-2 py-3 text-xs sm:text-sm text-gray-700 font-medium">{index + 1}</td>
                <td className="px-2 py-3 text-xs sm:text-sm text-gray-700 font-medium">{application.name || "-"}</td>
                <td className="hidden sm:table-cell px-2 py-3 text-xs sm:text-sm">{application.email || "-"}</td>
                <td className="hidden sm:table-cell px-2 py-3 text-xs sm:text-sm">{application.phone || "-"}</td>
                <td className="hidden sm:table-cell px-2 py-3 text-xs sm:text-sm">{application.subject || "-"}</td>
                {/* <td className="px-2 py-3 text-xs sm:text-sm">
                  {application.resume ? (
                    <a
                      href={application.resume}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:text-blue-700"
                    >
                      View Resume
                    </a>
                  ) : (
                    <span className="text-gray-500">No Resume</span>
                  )}
                </td> */}
                <td className="px-2 py-3 text-xs sm:text-sm">
                  {application.resume ? (
                    <a
                      href={`/uploads/resumes/${application.resume}`}// The path returned from the backend
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:text-blue-700"
                    >
                      View Resume
                    </a>
                  ) : (
                    <span className="text-gray-500">No Resume</span>
                  )}
                </td>


                <td className="px-2 py-3 text-center space-x-1 sm:space-x-3">
                  <button
                    onClick={() => handleViewClick(application)}
                    className="text-blue-500 hover:text-blue-700 transition duration-300"
                    title="View Application"
                  >
                    <FaEye size={16} />
                  </button>
                  <button
                    onClick={() => handleDelete(application._id)}
                    className="text-red-500 hover:text-red-700 transition duration-300"
                    title="Delete Application"
                  >
                    <FaTrash size={16} />
                  </button>
                  {application.resume && (
                    <button
                      onClick={() => handleDownloadResume(application.resume)}
                      className="text-green-500 hover:text-green-700 transition duration-300"
                      title="Download Resume"
                    >
                      <FaDownload size={16} />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-gray-700 bg-opacity-60 flex justify-center items-center z-50">
          <div
            className="bg-white rounded-lg shadow-2xl w-11/12 md:w-1/2 lg:w-1/3 p-6 space-y-4 transform transition-all duration-500 scale-100 opacity-100"
            style={{ animation: "fadeIn 0.5s ease, scaleUp 0.5s ease" }}
          >
            <h2 className="text-xl font-bold text-teal-600 text-center">
              View Teacher Application
            </h2>
            <div className="space-y-3 text-sm text-gray-700">
              <div className="flex justify-between">
                <span className="font-medium">Name:</span>
                <span>{selectedApplication?.name || "N/A"}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Email:</span>
                <span>{selectedApplication?.email || "N/A"}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Phone:</span>
                <span>{selectedApplication?.phone || "N/A"}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Qualification:</span>
                <span>{selectedApplication?.qualification || "N/A"}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Experience:</span>
                <span>{selectedApplication?.experience || "N/A"}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Subject:</span>
                <span>{selectedApplication?.subject || "N/A"}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Resume:</span>
                {selectedApplication?.resume ? (
                  <a
                    href={selectedApplication?.resume}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    View Resume
                  </a>
                ) : (
                  <span>No resume uploaded</span>
                )}
              </div>
            </div>
            <div className="flex justify-end pt-4">
              <button
                onClick={closeModal}
                className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition duration-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes scaleUp {
    from {
      transform: scale(0.9);
    }
    to {
      transform: scale(1);
    }
  }
`}</style>




    </div>
  );
}
